// extracted by mini-css-extract-plugin
export var pickerModal = "_ft-0";
export var xButton = "_ft-1";